<template>
  <v-container :fill-height='loading'>
   <v-layout v-if="loading"
      align-center
      justify-space-around
      wrap
      fill-height
    style="background:var(--background-grey); height:100vh;"
      >
      <v-progress-circular
          indeterminate
          color="primary"
          :size="50">
          </v-progress-circular>
    </v-layout>
    <v-layout row wrap v-else>
      <v-flex xs12>
        <div class="add-page-head ">
          <span :class="{'display-4 section-head d-block' : $vuetify.breakpoint.xsOnly, 'display-3 section-head d-block' : !$vuetify.breakpoint.xsOnly}">Quotes</span>
          <span class="body-small font-weight-bold pt-1 d-block">View, search, download and edit your quotes</span>
        </div>
      </v-flex>
      <v-flex xs12 v-if="error">
        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
      </v-flex>
      <v-flex xs12 v-if="!hasProAccess" >
        <div class="app-panel" :class="{'white px-1 pb-5 pt-4' : $vuetify.breakpoint.xsOnly, 'white px-3 pb-5 pt-4' : !$vuetify.breakpoint.xsOnly}">
          <v-layout :class="{'px-3 pb-3' : $vuetify.breakpoint.xsOnly, 'px-0 ' : !$vuetify.breakpoint.xsOnly}">
          <v-flex grow>
            <span class="subheading">Upgrade your account to use Quotes.</span>
            <p>Quotes are for paid <strong>Pro</strong> plans only.</p>
            <p class="mt-3">With the Pro plan, Easily send quotes to your clients in seconds and be alerted when your client digitally accepts them. Convert them to an invoice with a single click.</p>
            <v-btn class="v-btn--medium " depressed small color="primary" to="/settings/billing" >Upgrade my account</v-btn>
          </v-flex>
        </v-layout>
      </div>
      </v-flex>
      <v-flex xs12 v-else>
          <div class="app-panel" :class="{'white px-1 pb-5 pt-4' : $vuetify.breakpoint.xsOnly, 'white px-3 pb-5 pt-4' : !$vuetify.breakpoint.xsOnly}">
          <v-layout :class="{'px-3 pb-3' : $vuetify.breakpoint.xsOnly, 'px-0 pb-5 ' : !$vuetify.breakpoint.xsOnly}">
            <v-flex >
                <v-text-field
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  :autofocus="!$vuetify.breakpoint.xsOnly"
                  clearable
                  v-model="search"
                ></v-text-field>
              </v-flex>
            </v-layout>
          <v-data-table
              :headers="headers"
              :items="quotes"
              hide-actions
              :search="search"
              class="datatable"
              :pagination.sync="pagination"
              :loading="loading"
            >
            <template slot="items" slot-scope="props">
              <router-link :to="{ name: 'Quote', params: {quote_id: props.item.id} }" style="cursor:pointer;" tag="tr">
                <td class="text-xs-left body-small">{{ props.item.clientName }}</td>
                <td class="text-xs-left body-small pt-1 pb-1">{{ props.item.quote_ref }}</td>
                <td class="text-xs-left body-small"><display-amount :totalAmount="props.item.amount" :totalNetAmount="props.item.totalNetAmount"></display-amount></td>
                <td class="text-xs-left body-small">{{ formatDate(props.item.quoted_date) }} </td>
                <td class="text-xs-left body-small" v-html="niceStatus(props.item)"></td>
              </router-link>
            </template>
            <template slot="pageText" slot-scope="{ pageStart, pageStop }">
              From {{ pageStart }} to {{ pageStop }}
            </template>
          </v-data-table>
        </div>
        </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import { formatDate } from '@/components/Mixins/formatDate'
import moment from 'moment-timezone'
import DisplayAmount from '@/components/Shared/DisplayAmount'

export default {
  components: {
    DisplayAmount
  },
  mixins: [formatDate],
  data () {
    return {
      search: '',
      pagination: {
        descending: true,
        rowsPerPage: -1,
        sortBy: 'invoiced_date'
      },
      headers: [
        { text: 'Client', value: 'clientName', align: 'left', class: 'body-2 font-weight-bold' },
        { text: 'Ref', value: 'quote_ref', align: 'left', class: 'body-2 font-weight-bold' },
        { text: 'Total', value: 'amount', align: 'left', class: 'body-2 font-weight-bold' },
        { text: 'Quoted Date', value: 'invoiced_date', align: 'left', class: 'body-2 font-weight-bold' },
        { text: 'Status', value: 'paid_date', align: 'left', class: 'body-2 font-weight-bold', sortable: false }
      ],
      user: this.$store.getters.user,
      quotes: [],
      alertThreshold: this.$store.getters.group.chosenAlertTimeScale,
      lang: this.$store.getters.group.lang,
      currCode: this.$store.getters.group.currCode,
      currSymbol: this.$store.getters.group.currSymbol
    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    hasProAccess () {
      return this.$store.getters.hasProAccess
    }
  },
  watch: {
    pagination (newName) {
      localStorage.quoOrderBy = newName
      const parsed = JSON.stringify(newName)
      localStorage.setItem('quo-pagination', parsed)
    },
    search (newSearch) {
      localStorage.quoSearch = newSearch
      const parsed = JSON.stringify(newSearch)
      localStorage.setItem('quo-search', parsed)
    }
  },
  methods: {
    niceStatus (item) {
      if (item.status === 'Quote sent') {
        // if invoice date + alerttimescale is earlier than today then it's overdue
        if (moment(item.invoiced_date).add(this.alertThreshold, 'days').isBefore(Date.now())) {
          return `<span class="error--text">Overdue - Sent ${this.formatDateFromNow(item.invoiced_date)}</span>`
        } else {
          // it's sent but not overdue
          return `<span class="primary--text">Sent ${this.formatDateFromNow(item.sentTimeStamp)}</span>`
        }
      } else if (item.status === 'Unsent') {
        return `Unsent`
      } else if (item.status === 'Accepted') {
        return `<span class="accent--text">Accepted on ${this.formatDate(item.accepted_date)}</span>`
      }
    },
    fetchData () {
      firebase.database().ref('quotes/' + this.user.group).once('value')
        .then(data => {
          const obj = data.val()
          for (let key in obj) {
            this.quotes.push(obj[key])
          }
          this.$store.commit('setLoading', false)
        })
        .catch(
          (error) => {
            this.$store.commit('setError', error)
            this.$store.commit('setLoading', false)
          }
        )
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  },
  mounted () {
    if (localStorage.getItem('quo-pagination')) {
      try {
        this.pagination = JSON.parse(localStorage.getItem('quo-pagination'))
      } catch (e) {
        localStorage.removeItem('quo-pagination')
      }
    }
    if (localStorage.getItem('quo-search')) {
      try {
        this.search = JSON.parse(localStorage.getItem('quo-search'))
      } catch (e) {
        localStorage.removeItem('quo-search')
      }
    }
  },
  created () {
    this.fetchData()
  }
}
</script>
